import { object, SchemaOf } from 'yup';
import { OrganisationShape } from '../../schemas/Organisation.schemas';
import { OrganisationFormContentType } from './OrganisationForm.types';

export const OrganisationFormSchema: SchemaOf<OrganisationFormContentType> = object({
  ...OrganisationShape,
});
